import { reactive } from 'vue';
import { $dt } from '@primevue/themes';

export const useColors = () => {
  const colors = reactive({
    primary: {
      color: $dt('primary.color')?.variable,
    },
    surface: {
      background: $dt('surface.0')?.variable,
      border: {
        primary: $dt('surface.200')?.variable,
        secondary: $dt('surface.300')?.variable,
      },
    },
    text: {
      primary: $dt('text.color')?.variable,
      primaryHover: $dt('text.hover.color')?.variable,
      muted: $dt('text.muted.color')?.variable,
      mutedHover: $dt('text.hover.muted.color')?.variable,
      error: $dt('red.600')?.variable,
    },
  });

  return colors;
};
